<div class="container p-3">
    <div class="row" *ngIf="watchface">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
            <watchface-card [watchface]="watchface" [approve]="approve" [reject]="reject" (approve)="clickApproveWatchface()" (reject)="clickRejectWatchface()"></watchface-card>
        </div>
    </div>
</div>